import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AiChatState, aiChatReducer } from './reducers/ai-chat.reducers';

export interface State {
  aiChat: AiChatState;
}

export const reducers = {
  aiChat: aiChatReducer,
};

export const selectAiChatState = createFeatureSelector<State>('aiChat');

export const selectAiChatDialogState = createSelector(selectAiChatState, (state: State) => state && state.aiChat);
